module.exports = __webpack_public_path__ + "img/52.cc2ef5ea.png";